export default __webpack_public_path__ + "static/media/accounts-color.a09b7df6.svg";